import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type BiometricsState = {
  isEnabled: boolean
  toggleBiometrics: () => void
  setBiometrics: (enabled: boolean) => void
}

export const useBiometricsStore = create<BiometricsState>()(
  persist(
    (set) => ({
      isEnabled: false, // Default state is disabled
      toggleBiometrics: () => set((state) => ({ isEnabled: !state.isEnabled })),
      setBiometrics: (enabled: boolean) => set({ isEnabled: enabled }),
    }),
    {
      name: 'biometrics-storage', // unique name for localStorage key
    }
  )
)
